(function() {
	'use strict';
	var $ = avm.require('cash');

	var sliderOurStories = tns({
		"container": ".sliderOurStories",
		"controlsContainer": ".sliderOurStories-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"autoplay": true,
		"autoplayButtonOutput": false,
		"autoplayTimeout": 8000,
		"mouseDrag": true,
		"speed": 400,
		"fixedWidth": 344,
		"center": true,
		"responsive": {
			"768": {
				"fixedWidth": 532
			},
			"992": {
				"controls": true,
				"fixedWidth":644
			},
			"1280": {
				"fixedWidth": 816
			},
			"1366": {
				"fixedWidth": 864
			},
			"1600": {
				"fixedWidth": 928
			}
		}
	});





})();
